export default "__VITE_ASSET__DJhX1GEG__"